import { render, staticRenderFns } from "./BrandsSwiper.vue?vue&type=template&id=75f3ceb2"
import script from "./BrandsSwiper.vue?vue&type=script&lang=ts"
export * from "./BrandsSwiper.vue?vue&type=script&lang=ts"
import style0 from "./BrandsSwiper.vue?vue&type=style&index=0&id=75f3ceb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports